// extracted by mini-css-extract-plugin
export default {"filterWrapper":"WorkCenterInfo_filterWrapper__a2sxl","spaceStyle":"WorkCenterInfo_spaceStyle__s0iuH"};